module.exports = __webpack_public_path__ + "img/20_80.d27b03de.png";